/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RolePagedList } from '../../models/role-paged-list';
import { RolesSearchBody } from '../../models/roles-search-body';
import { RolesSortFieldName } from '../../models/roles-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface SearchRoleList$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the name
 */
  sortFieldName?: RolesSortFieldName;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search roles
     */
    body?: RolesSearchBody
}

export function searchRoleList(http: HttpClient, rootUrl: string, params?: SearchRoleList$Params, context?: HttpContext): Observable<StrictHttpResponse<RolePagedList>> {
  const rb = new RequestBuilder(rootUrl, searchRoleList.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RolePagedList>;
    })
  );
}

searchRoleList.PATH = '/administration/roles/search';
